import type { ActivityInput, MethodId } from "../schema/scenario";
import type { EmissionFactor } from "../schema/master";
import type { EfApplied } from "./types";

/** 방식에 맞는 계수만 남긴다 , cert 전용 계수가 있으면 그것이 both 보다 앞선다 */
export function factorsForMethod(factors: EmissionFactor[], method: MethodId): EmissionFactor[] {
  return factors.filter((f) => f.active && (f.scope === "both" || f.scope === method));
}

export function findFactor(factors: EmissionFactor[], id: string): EmissionFactor | undefined {
  return factors.find((f) => f.id === id && f.active);
}

/** kind 의 기본 계수. 방식 전용 → both 순으로, isDefault 우선 */
export function defaultFactorFor(factors: EmissionFactor[], kind: string, method: MethodId): EmissionFactor | undefined {
  const candidates = factorsForMethod(factors, method).filter((f) => f.kind === kind);
  const specific = candidates.filter((f) => f.scope === method);
  const pool = specific.length ? specific : candidates;
  return pool.find((f) => f.isDefault) ?? pool[0];
}

export function toApplied(f: EmissionFactor): EfApplied {
  return { id: f.id, name: f.name, value: f.value, unit: f.unit, source: f.source, baseYear: f.baseYear, status: f.status, sourceUrl: f.sourceUrl, gwpBasis: f.gwpBasis };
}

/** 입력 항목 하나에 붙일 계수. customEf → efId → kind 기본 순 */
export function resolveFactor(input: ActivityInput, factors: EmissionFactor[], method: MethodId): EfApplied | null {
  if (input.customEf) {
    return {
      id: `custom:${input.id}`,
      name: `${input.label} (사용자 정의 계수)`,
      value: input.customEf.value,
      unit: input.customEf.unit,
      source: input.customEf.source,
      baseYear: input.customEf.baseYear ?? 0,
      status: "user",
    };
  }
  if (input.efId) {
    const f = findFactor(factors, input.efId);
    return f ? toApplied(f) : null;
  }
  const f = defaultFactorFor(factors, input.kind, method);
  return f ? toApplied(f) : null;
}
